// MORЄ quick add: one size tap adds the variant to the bag and opens Dawn's cart drawer.
(function () {
  function openDrawer(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qa-toggle]');
    if (toggle) {
      var box = toggle.closest('[data-quick-add]');
      document.querySelectorAll('[data-quick-add].is-open').forEach(function (b) { if (b !== box) b.classList.remove('is-open'); });
      box.classList.toggle('is-open');
      return;
    }
    var btn = e.target.closest('[data-qa-variant]');
    if (!btn || btn.disabled || !btn.dataset.qaVariant) return;
    var qa = btn.closest('[data-quick-add]');
    var msg = qa.querySelector('.more-qa__msg');
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.qaVariant), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (state) {
        btn.classList.remove('is-loading');
        qa.classList.remove('is-open');
        var item = state.items && state.items[0];
        if (item) state.id = item.variant_id;
        if (!openDrawer(state)) { msg.textContent = 'Added to bag'; }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        msg.textContent = (err && err.description) || 'This size just sold out. Pick another one.';
      });
  });
})();

// MORЄ card gallery: arrows page through the photos; on desktop, hovering the card shows the second photo
// (and leaving returns to the first). Phones swipe the track. Delegated, so cards re-rendered by filters keep working.
(function () {
  function go(track, i) {
    var n = track.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth });
  }
  function index(track) { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-card-nav]');
    if (!nav) return;
    e.preventDefault();
    var track = nav.closest('.more-card__img').querySelector('[data-card-track]');
    if (!track) return;
    var n = track.children.length, next = index(track) + Number(nav.dataset.cardNav);
    go(track, (next + n) % n);
  });

  if (!window.matchMedia('(hover: hover)').matches) return;
  document.addEventListener('mouseover', function (e) {
    var img = e.target.closest('.more-card__img');
    if (!img || img.contains(e.relatedTarget)) return;
    var track = img.querySelector('[data-card-track]');
    if (track && track.children.length > 1 && index(track) === 0) go(track, 1);
  });
  document.addEventListener('mouseout', function (e) {
    var img = e.target.closest('.more-card__img');
    if (!img || img.contains(e.relatedTarget)) return;
    var track = img.querySelector('[data-card-track]');
    if (track) go(track, 0);
  });
})();
